/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Automatic_Save_Skipped_LockedInputs */

const en_automatic_save_skipped_locked = /** @type {(inputs: Automatic_Save_Skipped_LockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic save skipped: Project is locked by ${i?.email}`)
};

const fr_automatic_save_skipped_locked = /** @type {(inputs: Automatic_Save_Skipped_LockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sauvegarde automatique ignorée : le projet est verrouillé par ${i?.email}`)
};

const de_automatic_save_skipped_locked = /** @type {(inputs: Automatic_Save_Skipped_LockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatisches Speichern übersprungen: Projekt ist von ${i?.email} gesperrt.`)
};

const it_automatic_save_skipped_locked = /** @type {(inputs: Automatic_Save_Skipped_LockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Salvataggio automatico saltato: il progetto è bloccato da ${i?.email}`)
};

const ru_automatic_save_skipped_locked = /** @type {(inputs: Automatic_Save_Skipped_LockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Автоматическое сохранение пропущено: Проект заблокирован пользователем ${i?.email}`)
};

const es_automatic_save_skipped_locked = /** @type {(inputs: Automatic_Save_Skipped_LockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guardado automático omitido: el proyecto está bloqueado por ${i?.email}`)
};

const zh_cn2_automatic_save_skipped_locked = /** @type {(inputs: Automatic_Save_Skipped_LockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`自动保存已跳过：项目已被 ${i?.email} 锁定`)
};

const ja_automatic_save_skipped_locked = /** @type {(inputs: Automatic_Save_Skipped_LockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`自動保存をスキップしました: プロジェクトは ${i?.email} によってロックされています`)
};

const hi_automatic_save_skipped_locked = /** @type {(inputs: Automatic_Save_Skipped_LockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्वचालित सेव प्रक्रिया रोक दी गई: प्रोजेक्ट ${i?.email} द्वारा लॉक किया गया है।`)
};

const pt_pt2_automatic_save_skipped_locked = /** @type {(inputs: Automatic_Save_Skipped_LockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Salvamento automático ignorado: O projeto está bloqueado por ${i?.email}`)
};

/**
* | output |
* | --- |
* | "Automatic save skipped: Project is locked by {email}" |
*
* @param {Automatic_Save_Skipped_LockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_skipped_locked = /** @type {((inputs: Automatic_Save_Skipped_LockedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Skipped_LockedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_skipped_locked(inputs)
	if (locale === "de") return de_automatic_save_skipped_locked(inputs)
	if (locale === "it") return it_automatic_save_skipped_locked(inputs)
	if (locale === "ru") return ru_automatic_save_skipped_locked(inputs)
	if (locale === "es") return es_automatic_save_skipped_locked(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_skipped_locked(inputs)
	if (locale === "ja") return ja_automatic_save_skipped_locked(inputs)
	if (locale === "hi") return hi_automatic_save_skipped_locked(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_skipped_locked(inputs)
	return en_automatic_save_skipped_locked(inputs)
});